import { useTheme } from "@mui/material";
import { SparkLineChart } from "@mui/x-charts/SparkLineChart";
import { MarkPlot } from "@mui/x-charts/LineChart";

interface InventoryDataPoint {
  value: number;
  label: string;
}

interface InventorySparklineProps {
  dataPoints: InventoryDataPoint[];
  width?: number;
  height?: number;
}

const formatInventoryTooltip = (value: number) =>
  `${Math.round(value).toLocaleString()}t`;

export const InventorySparkline = ({
  dataPoints,
  width = 80,
  height = 32,
}: InventorySparklineProps) => {
  const theme = useTheme();
  const color = theme.palette.data.lightblue;

  if (dataPoints.length < 2) {
    return null;
  }

  const values = dataPoints.map((dp) => dp.value);
  const labels = dataPoints.map((dp) => dp.label);

  return (
    <SparkLineChart
      data={values}
      xAxis={{
        scaleType: "point",
        data: labels,
      }}
      width={width}
      height={height}
      curve="linear"
      area
      showTooltip
      valueFormatter={(value) => formatInventoryTooltip(value ?? 0)}
      slotProps={{
        tooltip: {
          sx: {
            "& .MuiChartsTooltip-mark": {
              borderColor: color,
              backgroundColor: color,
            },
          },
        },
      }}
      sx={{
        "& .MuiLineElement-root": {
          stroke: color,
        },
        "& .MuiAreaElement-root": {
          fill: color,
          fillOpacity: 0.4,
        },
        "& .MuiMarkElement-root": {
          display: "none",
        },
        "& .MuiMarkElement-root:last-of-type": {
          display: "block",
          fill: color,
          stroke: color,
          r: 4,
          transform: "translateX(-4px)",
        },
        "& .MuiHighlightElement-root": {
          fill: color,
          stroke: color,
        },
      }}
    >
      <MarkPlot />
    </SparkLineChart>
  );
};
